var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"loader",staticClass:"lms-loader"},[_c('div',{staticClass:"inner-circle"}),_c('div',{staticClass:"middle-circle"}),_c('div',{staticClass:"outer-circle"})])
}
var staticRenderFns = []

export { render, staticRenderFns }